import { observer } from 'mobx-react';

import { DealCompare } from '@assets/component/DealCompare/DealCompare';
import { DealDashboard } from '@assets/component/DealDashboard/DealDashboard';
import { DealDetails } from '@assets/component/DealDetails/DealDetails';
import { DealScoreBreakdown } from '@assets/component/DealScoreBreakdown/DealScoreBreakdown';
import { Header } from '@assets/component/Header/Header';
import { Icon } from '@assets/component/Icons/Icons';
import { TaskPage } from '@assets/component/TaskPage/TaskPage';
import { Flex } from '@assets/component/UI/Flex/Flex';
import { useOnPageLoad } from '@assets/hooks/useOnPageLoad';
import {
    UIDealDetailsTabs,
    useClientSettingStore,
    useSetPageTitle,
    useStore,
    useStoreUI
} from '@assets/model/Store';
import { useNavUtils } from '@assets/utils/NavUtils';
import { useEffect } from 'react';
import { Tab, Tabs } from 'react-bootstrap';
import { useParams } from 'react-router-dom';
import DealChat from './DealChat';
import { DealFlowise } from './DealFlowise';
import { DealOutputs } from './DealOutputs';
import * as style from './DealView.module.less';
import { AdminSection } from '@assets/component/AdminSection/AdminSection';
import { WorkStreamPage } from './WorkstreamsPage';

require('./DealView.css');

const DealView = observer(() => {
    const { id } = useParams();
    const store = useStore();
    const uiStore = useStoreUI();
    const clientStore = useClientSettingStore();
    const navUtils = useNavUtils();
    useEffect(() => {
        if (!store.isLoaded) {
            return;
        }
        if (!store.reportDataDB.hasOwnProperty(id)) {
            navUtils.home();
        }
    }, [store.isLoaded]);

    useOnPageLoad('DEAL_VIEW', () => {
        uiStore.resetDealView();
    });

    useSetPageTitle(store.query?.value('company_name') ?? '');

    useEffect(() => {
        if (id) {
            console.log('Setting report id to', id);
            store.selectedReportId = id;
        }
    }, [id]);

    useEffect(() => {
        if (!uiStore.isKeyTabDown) {
            return;
        }

        const values = Object.values(UIDealDetailsTabs);
        const currentIndex = values.indexOf(uiStore.dealViewTab);
        uiStore.dealViewTab =
            values[
                (currentIndex +
                    (uiStore.isKeyShiftKeyDown ? -1 : 1) +
                    values.length) %
                    values.length
            ];
    }, [uiStore.isKeyTabDown]);

    if (store.query == null) {
        return null;
    }

    const do_we_have_pdf = store.query.report_has_pdf;
    return (
        <>
            <div
                className={'d-flex justify-content-center'}
                style={{ height: '100%' }}
            >
                <AdminSection />
                <Flex direction="column" className={'h-100 w-100'}>
                    <Header
                        disableTicker={true}
                        showDealDbLink={true}
                        showScore={
                            true &&
                            clientStore.showAggregateScores &&
                            do_we_have_pdf
                        }
                        showShadow={false}
                    />

                    <div
                        className={style.tabsShadow}
                        style={{
                            opacity:
                                uiStore.dealViewTab !=
                                UIDealDetailsTabs.FLOWISE_CHAT
                                    ? 1.0
                                    : 0.0
                        }}
                    ></div>
                    <Tabs
                        activeKey={uiStore.dealViewTab}
                        variant="underline"
                        className={'dealViewTabs'}
                        onSelect={k =>
                            (uiStore.dealViewTab = k as UIDealDetailsTabs)
                        }
                        mountOnEnter
                        unmountOnExit
                    >
                        <Tab
                            eventKey={UIDealDetailsTabs.DASHBOARD}
                            title="Dashboard"
                            className={style.container}
                        >
                            <DealDashboard />
                        </Tab>

                        {do_we_have_pdf && (
                            <Tab
                                eventKey={UIDealDetailsTabs.DETAILS}
                                title="Deal Details"
                                className={style.container}
                            >
                                <DealDetails />
                            </Tab>
                        )}
                        {do_we_have_pdf && (
                            <Tab
                                eventKey={UIDealDetailsTabs.COMPARE}
                                title="Benchmark & Comps"
                                className={style.container}
                            >
                                <DealCompare />
                            </Tab>
                        )}
                        {do_we_have_pdf && (
                            <Tab
                                eventKey={UIDealDetailsTabs.SCORE_BREAKDOWN}
                                title="Score Details"
                                className={style.container}
                            >
                                <DealScoreBreakdown />
                            </Tab>
                        )}
                        {/* {
                            <Tab
                                eventKey={UIDealDetailsTabs.FLOWISE_CHAT}
                                title="Research"
                            >
                                <DealFlowiseChat />
                            </Tab>
                        } */}
                        {clientStore.showWorkstreams && (
                            <Tab
                                eventKey={UIDealDetailsTabs.WORKSTREAMS}
                                title="Workstreams"
                                className={style.container}
                                style={{ paddingTop: 10 }}
                            >
                                <WorkStreamPage />
                            </Tab>
                        )}
                        {/* {clientStore.showWorkstreams && (
                            <Tab
                                eventKey={UIDealDetailsTabs.TASK_CHAT}
                                title="Task"
                                className={style.container}
                                style={{ paddingTop: 10 }}
                            >
                                <TaskPage />
                            </Tab>
                        )} */}
                        <Tab
                            eventKey={UIDealDetailsTabs.CHAT}
                            title={
                                <div
                                    className={style.gptTabLabel + ' nav-link'}
                                >
                                    AI Chat
                                    <Icon
                                        icon="sparkle"
                                        className={style.gptIcon}
                                    />
                                </div>
                            }
                            className={style.container}
                        >
                            <DealChat />
                        </Tab>

                        {store.isAdmin && store.showAdminConsole && (
                            <Tab
                                eventKey={UIDealDetailsTabs.FLOWISE}
                                title="Flowise Debug"
                                className={style.container}
                            >
                                <DealFlowise />
                            </Tab>
                        )}

                        {clientStore.showOutputsTab && (
                            <Tab
                                eventKey={UIDealDetailsTabs.OUTPUTS}
                                title="Outputs"
                                className={style.container}
                            >
                                <DealOutputs />
                            </Tab>
                        )}
                    </Tabs>
                    <div className={style.container}></div>
                </Flex>
            </div>
        </>
    );
});

export default DealView;
